import { number, string } from "yup";
import * as types from "./types";

export const UserInitialState = {
  //post request of user
  userPost: null,
  userPostLoading: false,
  userPostError: null,

  //get request of users
  allUser: [],
  allUserLoading: false,
  allUserError: null,

  //get Indivisual User
  user: [],
  userLoading: false,
  userError: null,

  //get Specific User
  // specificUser: {
  //   company:"",
  //   dfs_id:0,
  //   image_url:"",
  //   name:"",
  //   roles:{
  //     name:null,
  //     role_id:""
  //   },
  //   user_id:"",
  //   username:""
  // },
  specificUser: null as any,
  specificUserLoading: false,
  specificUserError: null,

  //user report
  reportData: null,
};

export const userReducer = (state = UserInitialState, action: any) => {
  switch (action.type) {
    case types.USER_POST_START:
      return {
        ...state,
        userPostLoading: true,
      };
    case types.USER_POST_SUCCESS:
      return {
        ...state,
        allUser: [...state.allUser, action.allUser],
        userPostLoading: false,
      };

    case types.USER_POST_FAILURE:
      return {
        ...state,
        userPostError: action.userPostError,
        userPostLoading: false,
      };

    case types.ALL_USER_FETCH_START:
      return {
        ...state,
        allUserLoading: true,
      };
    case types.ALL_USER_FETCH_SUCCESS:
      return {
        ...state,
        allUser: action.allUser.data,
        allUserLoading: false,
      };

    case types.ALL_USER_FETCH_FINISH:
      return {
        ...state,
        allUserError: action.allUserError,
        allUserLoading: false,
      };

    case types.USER_FETCH_START:
      return {
        ...state,
        userLoading: true,
      };
    case types.USER_FETCH_SUCCESS:
      return {
        ...state,
        user: action.user,
        userLoading: false,
      };

    case types.USER_FETCH_FAILURE:
      return {
        ...state,
        userError: action.userError,
        allUserLoading: false,
      };

    case types.SPECIFIC_USER_START:
      return {
        ...state,
        specificUserLoading: true,
      };
    case types.SPECIFIC_USER_SUCCESS:
      return {
        ...state,
        specificUser: action.specificUser,
        specificUserLoading: false,
      };

    case types.SPECIFIC_USER_FAILURE:
      return {
        ...state,
        specificUserError: action.specificUserError,
        specificUserLoading: false,
      };

    case types.GET_REPORT_DATA:
      return {
        ...state,
        reportData: action.reportData,
      };
    case types.USER_REPORT_CLEAR:
      return {
        ...state,
        reportData: null
      }
    default:
      return state;
  }
};
